import { Button, Form, InputGroup } from "react-bootstrap";
import "./CardName.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { faSave } from "@fortawesome/free-solid-svg-icons";
import useOutsideClick from "../../util/useOutsideClick";

function FormName({ name, placeholder, updateHandler, onlyRead, editingMode, loading, log, hide, setHide }) {

    const [edit, setEdit] = useState(false);
    const [logForm, setLogForm] = useState(null);
    const [text, setText] = useState(null);

    function EditTextHandler() {
        setLogForm(null);
        if (text === null || text === undefined || text === "" || text === "Название задачи...") {
            setLogForm("Введите название");
        }
        else {
            // setEdit(false);
            if (updateHandler !== undefined & name != text) {
                updateHandler(text);
            }
            else {
                setEdit(false);
            }
        }
    }
    function KeyPressHandler(e) {
        if (e.key === 'Enter') {
            EditTextHandler();
        }
    }

    useEffect(() => {
        if (hide === true) {
            setEdit(false)
        }
    }, [hide]);

    useEffect(() => {
        setText(name);
    }, [name]);

    useEffect(() => {
        if (editingMode === true) {
            setEdit(true);
        }
    }, [editingMode]);

    const outsideClick = useOutsideClick(() => {
        EditTextHandler();
    });

    function editShow() {
        setEdit(true);

        if (setHide != null) {
            setHide(false);
        }

    }

    return (
        <>
            {edit === true ?
                (
                    <div ref={outsideClick}>
                        <InputGroup >
                            <Form.Control
                                placeholder={placeholder === undefined ? "Название задачи..." : placeholder}
                                onChange={(e) => setText(e.target.value)}
                                onBlur={() => EditTextHandler()}
                                onKeyDown={(e) => KeyPressHandler(e)}
                                disabled={loading}
                                defaultValue={name === 'Название задачи...' ? null : name}
                            />
                            <Button variant="outline-success" onClick={() => EditTextHandler()} disabled={loading}>
                                <FontAwesomeIcon icon={faSave} />
                            </Button>
                        </InputGroup>
                        <div>
                            {logForm !== null && <div className="form_error text-center">{logForm}</div>}
                        </div>
                        <div>
                            {log !== null && <div className="form_error text-center">{log}</div>}
                        </div>
                    </div>
                )
                :
                (
                    <div className="form_name" onClick={() => onlyRead === false && editShow()}>{name === null ? placeholder : name}</div >
                )
            }
        </>
    )
}

export default FormName;